import { Link } from "react-router-dom";
import { Award, Sparkles, MapPin, Users } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative min-h-[60vh] flex items-center overflow-hidden">
        <img src="https://images.unsplash.com/photo-1617633150878-7df1d12a9a57?q=80&w=2000" alt="" className="absolute inset-0 w-full h-full object-cover opacity-50"/>
        <div className="absolute inset-0 bg-gradient-to-b from-[#12100E]/60 to-[#12100E]"/>
        <div className="relative max-w-4xl mx-auto text-center px-6 py-20">
          <div className="eyebrow">The Atelier</div>
          <h1 className="font-serif-luxe text-5xl sm:text-6xl lg:text-7xl text-[#FAF8F5] mt-6 leading-tight">A House Built on <span className="italic text-[#D4AF37]">Aura</span></h1>
          <p className="text-[#C2B29F] mt-6 max-w-2xl mx-auto">
            Laxmi Aura Jewels is a modern Indian jewellery house founded in Jaipur — where every piece is
            hand-crafted, hallmarked, and imbued with a quiet divine radiance.
          </p>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="eyebrow">Founder's Note</div>
          <h2 className="font-serif-luxe text-4xl text-[#FAF8F5] mt-3">By Lakshya Soni</h2>
          <p className="mt-6 text-[#C2B29F] leading-relaxed">
            "I grew up in the narrow lanes of Johari Bazaar in Jaipur, watching my grandfather set uncut polki
            stones by candlelight. To him, every piece he made carried a soul — an aura that would be passed from
            mother to daughter, generation after generation."
          </p>
          <p className="mt-4 text-[#C2B29F] leading-relaxed">
            "Laxmi Aura is my prayer to that inheritance. Every stone we set is real, every gram of gold is hallmarked,
            and every piece is made to be worn for a lifetime — and then some."
          </p>
          <div className="mt-6 font-serif-luxe italic text-[#D4AF37]">— Lakshya Soni, Founder</div>
        </div>
        <div className="aspect-[4/5] bg-[#221712] overflow-hidden">
          <img src="https://images.unsplash.com/photo-1611955167811-4711904bb9f8?q=80&w=1400" alt="Craft" className="w-full h-full object-cover"/>
        </div>
      </section>

      <section className="bg-[#0f0c0a] border-y border-[#D4AF37]/15 py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            {i: Award, t: "4th Generation", s: "Family of master jewellers"},
            {i: Users, t: "60+ Karigars", s: "Handcraft every piece in Jaipur"},
            {i: MapPin, t: "Since 1962", s: "Rooted in Johari Bazaar heritage"},
            {i: Sparkles, t: "100% Certified", s: "BIS Hallmark & IGI/GIA"},
          ].map((x, i) => (
            <div key={i} className="text-center">
              <x.i size={28} className="text-[#D4AF37] mx-auto mb-3"/>
              <div className="font-serif-luxe text-2xl text-[#FAF8F5]">{x.t}</div>
              <div className="text-xs text-[#C2B29F] mt-1">{x.s}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto text-center px-6 py-24">
        <div className="eyebrow">Come Visit</div>
        <h2 className="font-serif-luxe text-4xl text-[#FAF8F5] mt-3">Experience Laxmi Aura in person</h2>
        <p className="text-[#C2B29F] mt-4">Book a private viewing at our Jaipur atelier for a bespoke consultation.</p>
        <Link to="/contact" className="btn-gold mt-8 inline-flex">Book a Viewing</Link>
      </section>
    </div>
  );
}
